const snakeToCamel = (s) => s.replace(/(_\w)/g, (k) => k[1].toUpperCase());

const mapToCamelCase = (start) => {
  return Object.fromEntries(Object.entries(start).map(([key, value]) => [String(key).includes('_') ? snakeToCamel(key) : key, value]));
};

export default mapToCamelCase;
